export default "__VITE_ASSET__B6wGQY79__"